module.exports = __webpack_public_path__ + "static/media/s4.bc95623a.png";